module.exports = __webpack_public_path__ + "img/img1.c4a8db38.jpg";